function showResponseSlider(formInfo) {
    var sliderType = "numbers";
    var rMin = "";
    var rMax = "";
    var rMinLabel = "";
    var rMaxLabel = "";
    var rValues = "";
    var rStart = "";
    var rStartLabel = "";
    var rStep = 1;
    var rHideValue = "false";
    var rHideRange = "false";
    var rShowLabels = "true";
    var rGridNum = "";
    rHideValue = false;
    rHideStart = false;
    rHideGrid = false;
    rHideMinMax = false;
    // var rangeLabelId = currentElementId + 'label';
    var currentElementId = "slider1";
    var qBuild = "";

    formInfo.multiLineSlider = true;

    var sliderResponseChoices = new Array();
    var sliderResponseChoices = formInfo.responseChoices[0].split('_').filter(function(c) {
        return c.length != 0
    });
    console.log(sliderResponseChoices);
    console.log(sliderResponseChoices.length);
    //eliminate min and max labels if any
    if (sliderResponseChoices[0].indexOf('(') > -1) {
        var separators = ['\\\(', '\\\)'];
        tempSplit = sliderResponseChoices[0].split(new RegExp(separators.join('|'), 'g')).filter(function(c) {
            return c.length != 0
        });
        sliderResponseChoices[0] = tempSplit[0];
        rMinLabel = tempSplit[1];
    }
    if (sliderResponseChoices.length > 1 && sliderResponseChoices[1].indexOf('(') > -1) {
        var separators = ['\\\(', '\\\)'];
        tempSplit = sliderResponseChoices[1].split(new RegExp(separators.join('|'), 'g')).filter(function(c) {
            return c.length != 0
        });
        sliderResponseChoices[1] = tempSplit[0];
        rMaxLabel = tempSplit[1];
    }

    //get info
    if (sliderResponseChoices.length == 1) {
        if (isNumeric(sliderResponseChoices[0])) {
            rMin = 0;
            rMax = sliderResponseChoices[0];
            rStart = 0;
        } else {
            rMin = 0;
            rMax = 100;
            rStart = 0;
        }

    } else if (sliderResponseChoices.length == 2) {
        if (!isNumeric(sliderResponseChoices[0]) || !isNumeric(sliderResponseChoices[1])) {
            sliderType = "labels";
            rValues = sliderResponseChoices.join(',');
            rStart = sliderResponseChoices[0];
            rStep = sliderResponseChoices.length;
        } else if (+sliderResponseChoices[0] > +sliderResponseChoices[1]) {
            rStart = 0;
            rMin = 0;
            rMax = sliderResponseChoices[0];
            rStep = sliderResponseChoices[1];
        } else {
            rStart = sliderResponseChoices[0];
            rMin = sliderResponseChoices[0];
            rMax = sliderResponseChoices[1];
        }
    } else if (sliderResponseChoices.length == 3) {
        if (!isNumeric(sliderResponseChoices[0]) || !isNumeric(sliderResponseChoices[1]) || !isNumeric(sliderResponseChoices[2])) {
            if (!isNumeric(sliderResponseChoices[2])) {
                sliderType = "labels";
                rValues = sliderResponseChoices.join(',');
                rStart = sliderResponseChoices[0];
                rStep = sliderResponseChoices.length;
            } else {
                sliderType = "labels";
                rValues = sliderResponseChoices[0] + "," + sliderResponseChoices[1];
                rStart = sliderResponseChoices[0];
                rStep = sliderResponseChoices[2];
                rHideGrid = true;
            }
        } else {
            if ((+sliderResponseChoices[0] < +sliderResponseChoices[1]) && (+sliderResponseChoices[1] > +sliderResponseChoices[2])) {
                rStart = sliderResponseChoices[0];
                rMin = sliderResponseChoices[0];
                rMax = sliderResponseChoices[1];
                rStep = sliderResponseChoices[2];
            } else {
                rValues = sliderResponseChoices.join(',');
                rStart = sliderResponseChoices[0];
                rStep = sliderResponseChoices.length;
            }
        }
    } else {
        sliderType = "labels";
        rValues = sliderResponseChoices.join(',');
        rStart = sliderResponseChoices[0];
        rStep = sliderResponseChoices.length;
    }

    if (formInfo.responseChoices.length > 1) {
        rStart = formInfo.responseChoices[1];
    }
    if (!isNumeric(rStart)) {
        rStartLabel = sliderResponseChoices.indexOf(rStart);
    }
    if (formInfo.responseChoices.length > 1) {
        var flags = formInfo.responseChoices.slice(1);
        if (flags.indexOf('hideValue') > -1) {
            rHideValue = true;
        }
        if (flags.indexOf('hideStart') > -1) {
            rHideStart = true;
            rHideValue = true;
        }
        if (flags.indexOf('hideGrid') > -1) {
            rHideGrid = true;
        }
        if (flags.indexOf('hideMinMax') > -1) {
            rHideMinMax = true;
        }
    }

    if (formInfo.responseChoices.length > 4) {
        rShowLabels = formInfo.responseChoices[4];
    }

    var rowLabels = listTrialResponseRowsLabels[window.trialRow] || [""];

    for (var i = 0; i < rowLabels.length; i++) {
        currentElementId = 'slider' + (i + 1);
        var label = rowLabels[i];

        qBuild += '<div class="row" style="clear:both;line-height: 75px">';
        qBuild += '<div class="col-sm-2" style="text-align:right">' + label + '</div><div class="col-sm-7">';

        if (rMax > 0) {
            qBuild += '<input type="text" id="' + currentElementId + '" data-type="single" data-min="' + quoteattr(rMin) + '" data-max="' + quoteattr(rMax) + '" data-from="' + quoteattr(rStart) + '" data-step="' + quoteattr(rStep) +
                '" data-hide-min-max="' + rHideMinMax + '" data-hide-start="' + rHideStart + '" data-hide-from-to="' + rHideValue + '" data-grid="' + !rHideGrid + '" data-grid-num="20" data-grid-snap="true" class="rangeFormat sliderInput" data-min-label="' + rMinLabel + '" data-max-label="' + rMaxLabel + '" />';
        } else {
            qBuild += '<input type="text" id="' + currentElementId + '" data-type="single" data-from="' + quoteattr(rStartLabel) + '" data-values="' + quoteattr(rValues) + '" data-step="' + quoteattr(rStep) +
                '"data-hide-min-max="' + rHideMinMax + '" data-hide-start="' + rHideStart + '" data-hide-from-to="' + rHideValue + '" data-grid="' + !rHideGrid + '" data-grid-num="10" data-grid-snap="false" class="rangeFormat sliderInput" data-min-label="' + rMinLabel + '" data-max-label="' + rMaxLabel + '" />';
        }

        qBuild += '</div></div>';
    }

    $('#responseContainer').append(qBuild);
    formInfo.hideStart = rHideStart;
    formInfo.rMin = rMin;
    formInfo.rMax = rMax;
    formInfo.rStart = rStart;
    formInfo.rMinLabel = rMinLabel;
    formInfo.rMaxLabel = rMaxLabel;

    return $('#' + currentElementId);
}

function clearSliders(){
    $('#responseContainer').empty();
}

function generateSliderOptions(el, onSlidersReady, onTouched) {

    const options = columnForTrial('responseOptions', trialRow);
	var slider;
	var onceUpdated = false;
	var onceOnChange = false;
	var hideLabels = $(el).data('hide-from-to');
	var hideStart = $(el).data('hide-start');
	var noButton = options.indexOf('noButton') >= 0;
    var noFill = options.indexOf('removeFill') >= 0;
	console.log('hides', hideLabels, hideStart);
  
	var sliderOptions = {
	  onStart: function() {
		onSlidersReady && onSlidersReady();
	  },
	  onChange: function (data) {
  
		  //show labels if required: hideStart initially hides labels, because we do not want to see the first element selected
		  if (hideLabels && hideStart) {
			if (!slider) {
			  slider = $(el).data('ionRangeSlider');
			}
  
			// only first time
			slider && !onceUpdated && slider.update({
			  hide_from_to: false
			});

            if (noFill && !onceUpdated) {
                const parent = $(data.input).parent();
                parent.find('.irs-bar').hide();
                parent.find('.irs-bar-edge').hide();
            }

			onceUpdated = true;
		  }
  
		  if(data.from_value){
			  $(data.input).val(data.from_value);
		  }else{
			  $(data.input).val(data.from);
		  }
  
		  if (!onceOnChange) {
			onceOnChange = true;
			onTouched && onTouched();
			$(el).parent().find('.irs-slider').show();
			$(el).data('touched', true);
		  }

          if (options.indexOf('hideValue') >= 0) {
            const parent = $(data.input).parent();
            parent.find('.irs-single').hide();
          }
	  },
      onFinish: function () {
        if(noButton) {
            var responseTimestamp = performance.now();
            //small delay so the browser has a chance to update the slider? kinda hack-ish
            setTimeout(function(){
                clickSlider(null, responseTimestamp);
            }, 100)
		}
      },
	  type: 'single',
	  keyboard: true,
	  };
  
	sliderOptions.from = $(el).data('from');
  
	var minLabel = $(el).data('min-label');
	var maxLabel = $(el).data('max-label');
	var minValue = $(el).data('min');
	var maxValue = $(el).data('max');
  
	sliderOptions.prettify = function (n) {
  
	  if (maxLabel !='' && n == maxValue) {
		n = maxLabel;
	  }
  
	  if (minLabel !='' && n == minValue) {
		n = minLabel;
	  }
  
	  return n;
	}
  
	  return sliderOptions;
  }
